import { GenericService } from "./Generic.service";

export class AgendaService extends GenericService<any>{

    readonly URI: string = 'Agenda'

    constructor(){
        super()
        this.setUri(this.URI);
    }

    public async getAll(){
        return await super.getByResource('', { PageSize: 500 })
    }

    public async getById(id: string){
        return await super.getByResource(`${id}`,  { PageSize: 500 })
    }

    public async getAgendasProfissionais(){
        return await super.getByResource('Profissionais')
    }

    public async getByProfissionalId(profissionalId: string){
        return await super.getByResource('',  { ProfissionalId: profissionalId, PageSize: 500 })
    }

    public async getAgendasProfissionalMes(params: any){
        return await super.postByResource(params, 'ProfissionaisMes')
    }

    public async getAgendasProfissionalDia(params: any){
        return await super.postByResource(params, 'ProfissionaisDia')
    }

    public async getAgendasProfissionalDiaHorario(params: any){
        return await super.postByResource(params, 'ProfissionaisHorario')
    }

    public async register(agenda: any){
        return await super.post(agenda);
    }

    public async activateAgenda(body: any){
        return await super.postByResource(body, `ProfissionaisMes/Activate`)
    }

    public async inactivateAgenda(body: any){
        return await super.postByResource(body, `ProfissionaisMes/Inactivate`)
    }

    public async activateTurnoDia(turnoDiaId: string, agendaId: string){
        return await super.patchByResource(turnoDiaId, `${agendaId}/TurnoDia/${turnoDiaId}/Activate`)
    }

    public async inactivateTurnoDia(turnoDiaId: string, agendaId: string){
        return await super.patchByResource(turnoDiaId, `${agendaId}/TurnoDia/${turnoDiaId}/Inactivate`)
    }

    public async activateTurnoDiaHorario(turnoDiaId: string, agendaId: string, horarioId: string){
        return await super.patchByResource(turnoDiaId, `${agendaId}/TurnoDia/${turnoDiaId}/Horario/${horarioId}/Activate`)
    }

    public async inactivateTurnoDiaHorario(turnoDiaId: string, agendaId: string, horarioId: string){
        return await super.patchByResource(turnoDiaId, `${agendaId}/TurnoDia/${turnoDiaId}/Horario/${horarioId}/Inactivate`)
    }

    public async deleteAgenda(agendaId: string){
        return await super.deleteByResource({}, `${agendaId}`)
    }

    public async deleteAgendaTurnoDia(turnoDiaId: string, agendaId: string){
        return await super.deleteByResource({}, `${agendaId}/TurnoDia/${turnoDiaId}`)
    }
    
    public async deleteAgendaTurnoDiaHorario(turnoDiaId: string, agendaId: string, horarioId: string){
        return await super.deleteByResource({}, `${agendaId}/TurnoDia/${turnoDiaId}/Horario/${horarioId}`)
    }

    public async validateBusySchedules(params: any){
        return await super.postByResource(params, 'AgendaHorariosOcupados')
    }
}